module.exports = __webpack_public_path__ + "assets/img/Plakat2.6832ea08.png";